import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import _en from './translations/en.json.mjs';
import React from 'react';
import { Button, Modal, FormLayout, InlineGrid, TextField, Select } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { autobind } from '../../packages/@web-utilities/decorators/index.mjs';
import { DEFAULT_LINK, LinkTarget } from '../../types/index.mjs';
import compose from '@shopify/react-compose';

var _class;
// eslint-disable-next-line react/no-unsafe
let InsertLinkModal = (_class = class InsertLinkModal extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      link: this.props.selectedLink || DEFAULT_LINK
    };
    this.selectOptions = [{
      label: this.props.i18n.translate('InsertLinkModal.internalOption'),
      value: LinkTarget.Internal
    }, {
      label: this.props.i18n.translate('InsertLinkModal.externalOption'),
      value: LinkTarget.External
    }];
  }
  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      link: newProps.selectedLink || DEFAULT_LINK
    });
  }
  render() {
    const {
      i18n,
      open,
      onClose,
      onRemoveLink
    } = this.props;
    const {
      link
    } = this.state;
    const removeLinkButton = this.props.selectedLink == null ? null : /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      tone: "critical",
      onClick: onRemoveLink
    }, i18n.translate('RichTextEditor.removeLink'));
    const modalTitle = this.props.selectedLink == null ? i18n.translate('RichTextEditor.insertLink') : i18n.translate('RichTextEditor.editLink');
    return /*#__PURE__*/React.createElement(Modal, {
      title: modalTitle,
      open: open,
      onClose: onClose,
      primaryAction: {
        content: modalTitle,
        onAction: this.handleUpdateLink
      },
      secondaryActions: [{
        content: i18n.translate('RichTextEditor.cancel'),
        onAction: onClose
      }],
      footer: removeLinkButton,
      sectioned: true
    }, /*#__PURE__*/React.createElement(FormLayout, null, /*#__PURE__*/React.createElement(FormLayout.Group, null, /*#__PURE__*/React.createElement(InlineGrid, {
      columns: ['twoThirds', 'oneThird'],
      gap: "400"
    }, /*#__PURE__*/React.createElement(TextField, {
      autoComplete: "off",
      label: i18n.translate('InsertLinkModal.urlLabel'),
      helpText: i18n.translate('InsertLinkModal.urlHelpText'),
      placeholder: "http://",
      value: link.href,
      onChange: this.handleHrefChange
    }), /*#__PURE__*/React.createElement(Select, {
      label: i18n.translate('InsertLinkModal.selectLabel'),
      options: this.selectOptions,
      value: link.target,
      onChange: this.handleSelectChange
    }))), /*#__PURE__*/React.createElement(TextField, {
      autoComplete: "off",
      label: i18n.translate('InsertLinkModal.titleLabel'),
      helpText: i18n.translate('InsertLinkModal.titleHelpText'),
      value: link.title,
      onChange: this.handleTitleChange
    })));
  }
  handleUpdateLink() {
    const {
      link
    } = this.state;
    const {
      onUpdateLink
    } = this.props;
    onUpdateLink(link);
  }
  handleHrefChange(newHref) {
    this.setState(prevState => {
      return {
        link: {
          ...prevState.link,
          href: newHref
        }
      };
    });
  }
  handleTitleChange(newTitle) {
    this.setState(prevState => {
      return {
        link: {
          ...prevState.link,
          title: newTitle
        }
      };
    });
  }
  handleSelectChange(newTarget) {
    this.setState(prevState => {
      return {
        link: {
          ...prevState.link,
          target: newTarget
        }
      };
    });
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handleUpdateLink", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdateLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleHrefChange", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleHrefChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTitleChange", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleTitleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSelectChange", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleSelectChange"), _class.prototype)), _class);
var InsertLinkModal$1 = compose(withI18n({
  id: 'InsertLinkModal_lltqmc',
  fallback: _en,
  translations(locale) {
    if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
      return;
    }
    return import( /* webpackChunkName: "InsertLinkModal_lltqmc-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
  }
}))(InsertLinkModal);

export { InsertLinkModal$1 as default };
